import Component from './Component'

export default class ActionList extends Component {

	static _type = 'ActionList'

	form			// Parent form component

	input_el		// DOM Elements
	feedback_el

	tether () {
		super.tether()

		// Own DOM elements
		this.feedback_el = this.base.querySelector('.invalid-feedback')
		this.ul_el = this.base.querySelector('ul')

		// Enclosing form
		this.form = this.base.closest('form[anvil-component]').anvil

		// Create bound event handlers and register them
		this.inputListener = ActionList._inputListener.bind(this)
		this.updateListener = ActionList._updateListener.bind(this)

		$(this.ul_el).on('click', 'li', this.inputListener)								// jQuery event
		this.form.data.record.on(this.params.name + '-updated', this.updateListener)	// node event
	}

	static _inputListener (event) {

		// Send data to the record
		this.form.data[this.params.name] = $(event.currentTarget).data('value')
	}

	static _updateListener (value, errors) {

		// If the value changed, update it on the input as well
		$(this.ul_el).find('li').removeClass('active')
		$(this.ul_el).find(`li[data-value="${value}"]`).addClass('active')

		// Render validation
		this.renderValidation(errors)

		// Update hook
		if ('update' in this.params && typeof this.params.update == 'function') {
			this.params.update(value, this.params.name, this.form.data, this.params)
		}
	}

	renderValidation (errors) {
		if (errors == null) {
			// Validation successful
			$(this.ul_el).removeClass('is-invalid')
			$(this.feedback_el).html('')
		} else {
			// Invalid
			$(this.ul_el).addClass('is-invalid')
			$(this.feedback_el).html(errors.join('<br />'))
		}
	}

	destroy () {

		// Unregister event handlers
		$(this.ul_el).off('click', 'li', this.inputListener)
		this.form.data.record.off(this.params.name + '-updated', this.updateListener)

		delete this.feedback_el
		delete this.ul_el
		delete this.form

		super.destroy()
	}
}
